<template>
    <div id="scopeBusiness">
        <p class="serviceTitle"><span>解决方案</span></p>
        <div id="businessWrapper">
            <ul>
                <li v-for="(item,key) in serviceCont" :key="key" :class="item.addClass">
                    <div class="listTitle">
                        <span class="category">{{item.category}}</span>
                        {{item.title}}
                    </div>
                    <div class="listText">{{item.cont}}</div>
                    <router-link :to="{path:'/service/cont',query:{id:item.id}}" tag="div" class="listBtn">查看详情</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {service_data} from '@/assets/js/service.js'
// 引入data.js 文件
const serviceList = {
    service_data
}

export default {
    name: 'List2',
    data(){
        return{
            serviceCont:[]//数据
        }
    },
    mounted(){
        this.serviceCont = serviceList.service_data
    }
}
</script>

<style scoped>
    #businessWrapper>ul{
        width: 1116px;
        padding: 0 2px;
        overflow:hidden;
        margin: 0 auto;
    }
    #businessWrapper>ul>li{
        float: left;
        margin-right: 12px; 
        padding: 25px 15px 30px 15px;
        width: calc((100% - 120px) / 3);
        border:1px solid #f2f2f3;
        box-shadow: 0px 1px 2px 0px #ededf0;
        cursor: pointer;
        position: relative;
    }
    #businessWrapper>ul>li:nth-child(3n){
        margin-right: 0;
    }
    .listTitle{
        margin-bottom: 15px;
        font-size: 15px;
    }
    .category{
        color: #fff;
        padding: 2px 8px; 
        border-radius: 2px;
        margin-right: 5px;
    }
    .listText{
        color: #736f6e;
        text-indent: 22px;
        line-height: 25px;
        height: 125px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;     /*设置行数*/
        -webkit-box-orient: vertical;
    }
    .listBtn{
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        text-align: center;
        font-size: 10px;
        color: #fff;
        line-height: 37px;
        display: none;
    }
    #businessWrapper>ul>li:hover .listBtn{
        display: block; 
        animation:myChange 1.5s;
        -moz-animation:mChanget 1.5s; /* Firefox */
        -webkit-animation:myChange 1.5s; /* Safari and Chrome */
        -o-animation:myChange 1.5s; /* Opera */
    }
    @keyframes myChange {
        0%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }
    /* 不同颜色 */
    #businessWrapper>ul>li.green{
        border-top:2px solid #00bfdd;
    }
    li.green .category,li.green .listBtn{
        background: #00bfdd;
    }
    #businessWrapper>ul>li.orange{
        border-top:2px solid #f5a42f;
    }
    li.orange .category,li.orange .listBtn{
        background: #f5a42f;
    }
    #businessWrapper>ul>li.blue{
        border-top:2px solid #2d58c0;
    }
    li.blue .category,li.blue .listBtn{
        background: #2d58c0;
    }
    #businessWrapper>ul>li.blue-white{
        border-top:2px solid #7da0cd;
    }
    li.blue-white .category,li.blue-white .listBtn{
        background: #7da0cd;
    } 
</style>
